export const SET_LOCATION = "SET_LOCATION"
export const SET_LOCATION_ERROR = "SET_LOCATION_ERROR"